import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";
import withTheme from "../../../libs/themr/withTheme";
import styles from "./TabsCell.module.scss";

const TabsCell = ({ theme, onClick, id, title, selectedTabId, disabled }) => {
  return (
    <button
      type="button"
      className={cx(theme.tabsButtons, {
        [theme.selectedTab]: id === selectedTabId
      })}
      onClick={onClick}
      id={id}
      disabled={disabled}
    >
      {title}
    </button>
  );
};

TabsCell.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  selectedTabId: PropTypes.string,
  title: PropTypes.node,
  onClick: PropTypes.func,
  theme: PropTypes.object.isRequired
};
TabsCell.defaultProps = {
  disabled: false,
  selectedTabId: null,
  title: null,
  onClick: null
};

export default withTheme(styles)(React.memo(TabsCell));
